export const transformGroups = new WeakMap();
//# sourceMappingURL=groups.js.map